module.exports = __webpack_public_path__ + "assets/img/icon_qrcode.d75811f5.png";